import { combineReducers } from 'redux'
import { reducer as reduxForm } from 'redux-form'
import authReducer from './authReducer'
import surveysReducer from './surveysReducer'
import fahrerReducer from './fahrerReducer'
import fahrerUndUserReducer from './fahrerUndUserReducer'
import userReducer from './userReducer'
import errorReducer from './errorReducer'
import singleUserReducer from './singleUserReducer'
import lostPasswordReducer from './lostPasswordReducer'
import fuehrerscheinReducer from './fuehrerscheinReducer'

export default combineReducers({
	auth: authReducer,
	form: reduxForm,
	surveys: surveysReducer,
	fahrer: fahrerReducer,
	fahrerUndUser: fahrerUndUserReducer,
	users: userReducer,
	hinweis: errorReducer,
	singleUser: singleUserReducer,
	passwordLinkValid: lostPasswordReducer,
	fuehrerschein: fuehrerscheinReducer
});



// WEBPACK FOOTER //
// ./src/reducers/index.js